
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { useWebVitalsLogger } from "./hooks/useWebVitals";
import { preloadCriticalResources, optimizeImages, addResourceHints } from "./utils/performance";

// Import translation validator in development
if (process.env.NODE_ENV === 'development') {
  import('./utils/translationValidator');
}

// Initialize performance optimizations
if (typeof window !== 'undefined') {
  // Run immediately for critical path
  addResourceHints();
  
  // Run after DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    preloadCriticalResources();
    optimizeImages();
  });
}

// Initialize Web Vitals monitoring in production
function AppWithVitals() {
  useWebVitalsLogger();
  return <App />;
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppWithVitals />
  </StrictMode>
);
